import api from '@/api/index.js'

const account_credit_debit_logs = {
  state: {
    loading: false,
    data: [],
    error: null
  },

  mutations: {
    SET_ACCOUNT_CREDIT_DEBIT_LOGS_LOADING: (state, loading) => {
      state.loading = loading;
    },
    SET_ACCOUNT_CREDIT_DEBIT_LOGS: (state, response) => {
      state.data = response;
      state.loading = false;
    },
    SET_ACCOUNT_CREDIT_DEBIT_LOGS_ERROR: (state, error) => {
      state.error = error;
      state.loading = false;
    }
  },

  actions: {
    LoadAccountCreditDebitLogs({commit}, accountID) {
      commit('SET_ACCOUNT_CREDIT_DEBIT_LOGS_ERROR', null)
      commit('SET_ACCOUNT_CREDIT_DEBIT_LOGS_LOADING', true)
      return api.get(`accounts/${accountID}/credit-debit-logs?limit=150&offset=0`)
        .then((response) => {
          commit('SET_ACCOUNT_CREDIT_DEBIT_LOGS', response)
        })
        .catch((error) => {
          commit('SET_ACCOUNT_CREDIT_DEBIT_LOGS_ERROR', error)
          commit('SET_ERROR', error.bodyText == '' ? error.url + ' - ' + error.status : error.bodyText)
        })
    }
  },
}

export default account_credit_debit_logs
